import { Grid, Row, Col, Button, Modal } from 'react-bootstrap';
import React, { Component } from 'react';
import { connect } from "react-redux";

import { setData } from "../../redux/actionCreators";
import AuthenticationType from "../../components/authentication_type/AuthenticationType";
import saModalCloseImg from './../../resources/images/times-circle-solid.svg';
import saIconClaveUnicaImage from './../../resources/images/ic-unique-key-description.svg';
import saUniqueKeyImage from './../../resources/images/unique_key_description.svg';
import saQuestionsCheckImage from './../../resources/images/checklist.svg';
import saInfoCircleGrayIcon from './../../resources/images/information-cirlce-gray.svg';
import './selectAuthenticationType.css';
import AM from './../../config/authenticationMethods';
import { setErrorMessage, setErrorType, setShowError } from "../../redux/actionCreators";
import FooterContainer from '../../components/footer/FooterContainer';
import PageWithFooter from '../../components/page_with_footer/PageWithFooter';
import MainButton from '../../components/buttons/main_button/MainButton';
import TitleComponent from '../../components/title/TitleComponent';

class SelectAuthenticationType extends Component {

    CLAVE_UNICA_LOGIN = 'CLAVE_UNICA_LOGIN';

    constructor(props) {
        super(props);
        this.VALID_VALUES = [AM.CLAVE_UNICA_AUTH, AM.QUESTIONS_AUTH, this.CLAVE_UNICA_LOGIN];
        this.initModals = this.initModals.bind(this);
        this.state = {
            showModals: this.initModals()
        };
        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.onClickModalTrigger = this.onClickModalTrigger.bind(this);
        this.isValueSelected = this.isValueSelected.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.showModal = this.showModal.bind(this);
        this.onClickButtonContinue = this.onClickButtonContinue.bind(this);
        this.getAuthenticationType = this.getAuthenticationType.bind(this);
        this.loginClaveUnica = this.loginClaveUnica.bind(this);

        this.modalsInfo = {
            [AM.CLAVE_UNICA_AUTH]: {
                title: '',
                className: 'sat-modal',
                image: {
                    className: 'clave-unica-auth-img',
                    alt: 'Clave Única',
                    src: saUniqueKeyImage,
                },
                button: {
                    text: 'Aceptar',
                    className: '',
                    onClick: this.closeModal,
                },
                message: <>Para validar tu identidad puedes hacerlo con tu ClaveÚnica. Si aún no la tienes, infórmate sobre cómo obtenerla en el sitio Web del Registro Civil o, si lo prefieres, presencialmente en sus oficinas o en sucursales de Chile Atiende. Recuerda que también puedes responder algunas preguntas como alternativa para validarte.<br /><br /> <strong>Tendrás solo 5 minutos para iniciar sesión con tu ClaveÚnica.</strong></>,
            },
            [AM.QUESTIONS_AUTH]: {
                title: 'Preguntas',
                className: 'sat-modal',
                image: {
                    className: 'questions-auth-img',
                    alt: 'Preguntas',
                    src: saQuestionsCheckImage,
                },
                button: {
                    text: 'Aceptar',
                    className: '',
                    onClick: this.closeModal,
                },
                message: <>Para validar tu identidad <strong>te pedimos que contestes de forma correcta 5 preguntas</strong>. Como alternativa puedes validar tu identidad a través del inicio de sesión con clave única.</>,
            },
            [this.CLAVE_UNICA_LOGIN]: {
                title: '',
                className: 'sat-modal',
                image: {
                    className: 'clave-unica-auth-img',
                    alt: 'Clave Única',
                    src: saUniqueKeyImage,
                },
                button: {
                    text: 'Iniciar sesión',
                    className: '',
                    onClick: this.loginClaveUnica,
                    image: {
                        className: 'icon-clave-unica',
                        alt: 'Icon Clave Única',
                        src: saIconClaveUnicaImage,
                    },
                },
                additionalLinks: [
                    {
                        className: 'additional-link',
                        href: '#',
                        onClick: this.closeModal,
                        text: 'Volver',
                    },
                ],
                message: <>Se abrirá una nueva pantalla donde deberás ingresar tu RUT y ClaveÚnica<br /><br /> <strong>Tendrás 5 min. para iniciar sesión</strong></>,
            },
        };
    }

    initModals() {
        return {
            [AM.CLAVE_UNICA_AUTH]: false,
            [AM.QUESTIONS_AUTH]: false,
            [this.CLAVE_UNICA_LOGIN]: false,
        };
    }

    componentDidMount() {
        this.props.setData(this.props.stepData);
    }

    onChangeHandler(value) {
        this.props.setData({ AUTHENTICATION_TYPE: value });
    }

    onClickModalTrigger(value) {
        if (value) {
            if (this.VALID_VALUES.includes(value)) {
                const temp = {};
                temp[value] = true;
                const showModalsNew = { ...this.state.showModals, ...temp };
                this.setState({ showModals: showModalsNew });
            }
        }
    }

    isValueSelected(value) {
        let data = this.props.data ? this.props.data : this.props.stepData;
        return data.AUTHENTICATION_TYPE === value;
    }

    closeModal(event) {
        if (event) {
            event.preventDefault();
        }
        this.setState({ showModals: this.initModals() });
    }

    getAuthenticationType() {
        let data = this.props.data ? this.props.data : this.props.stepData;
        data = data ? data : {};
        return data.AUTHENTICATION_TYPE;
    }

    loginClaveUnica() {
        this.setState({ showModals: this.initModals() });
        this.props.nextStep();
    }

    onClickButtonContinue(event) {
        event.preventDefault();
        const authenticationMethod = this.getAuthenticationType();
        switch (authenticationMethod) {
            case AM.CLAVE_UNICA_AUTH:
                this.onClickModalTrigger(this.CLAVE_UNICA_LOGIN);
                break;
            case AM.QUESTIONS_AUTH:
            default:
                this.props.nextStep();
                break;
        }
    }

    showModal() {
        const modalToShow = Object.keys(this.modalsInfo).find(key => this.state.showModals[key]);
        if (!modalToShow) {
            return '';
        }
        let modalInfo = this.modalsInfo[modalToShow];

        return (
            <Modal
                show={true}
                bsSize="large"
                aria-labelledby="contained-modal-title-lg"
                className={modalInfo.className}
                onHide={this.closeModal}
            >
                <div className={`message-modal-content ${modalToShow === this.CLAVE_UNICA_LOGIN && "clave-unica"}`}>
                    <Modal.Header>
                        {<img src={modalInfo.image.src} className={modalInfo.image.className} alt={modalInfo.image.alt} />}
                        {modalInfo.title && <span className={'title'}>{modalInfo.title}</span>}
                        {<img src={saModalCloseImg} className={'close-modal'} alt={'Close'} onClick={this.closeModal} />}
                    </Modal.Header>
                    <Modal.Body>
                        <p className={'principal-message'}>{modalInfo.message}</p>
                    </Modal.Body>
                    <Modal.Footer style={{ textAlign: "center" }}>
                        {<Button onClick={modalInfo.button.onClick} className={modalInfo.button.className}>
                            {modalInfo.button.image &&
                                <img src={modalInfo.button.image.src}
                                    className={modalInfo.button.image.className}
                                    alt={modalInfo.button.image.alt} />} {modalInfo.button.text}
                        </Button>}
                        {modalInfo.hasOwnProperty('additionalLinks') && modalInfo.additionalLinks.length > 0
                            && modalInfo.additionalLinks.map((additionalLink, i) => {
                                return (<p key={`key-${i}`} className={additionalLink.className}>
                                    <a href={additionalLink.href} onClick={additionalLink.onClick}>{additionalLink.text}</a>
                                </p>);
                            })}
                    </Modal.Footer>
                </div>
            </Modal>
        );
    }

    render() {
        const authenticationMethod = this.getAuthenticationType();

        const uniqueKeyText = <><img src={saUniqueKeyImage} className={'unique-key-img'} alt={'Clave Única'} />
            <dd>Inicia sesión con tu clave única para validar tu identidad</dd></>;
        const questionsText = <><img src={saQuestionsCheckImage} className={'questions-img'} alt={'Preguntas'} />  <span>Preguntas</span><dd>Para validar tu identidad te pediremos responder algunas preguntas</dd></>;

        return (
            <div className={'select-authentication-type'}>
                
                <PageWithFooter
                    footer={(
                        <FooterContainer>
                            <MainButton 
                                onClick={this.onClickButtonContinue}
                                disabled={!authenticationMethod}
                                text={'Continuar'}
                            />
                        </FooterContainer>
                    )}
                >
                <Grid>
                    <div className="content">
                        <Row className={'question'}>
                            <Col xs={12} >
                                <TitleComponent subtitle>¿Cómo quieres autenticarte?</TitleComponent>
                            </Col>
                        </Row>

                        {this.props.stepInfo.authenticationMethods && this.props.stepInfo.authenticationMethods[AM.CLAVE_UNICA_AUTH] &&  <AuthenticationType
                            onChangeHandler={this.onChangeHandler}
                            value={AM.CLAVE_UNICA_AUTH}
                            name={'authentication-type'}
                            checked={this.isValueSelected(AM.CLAVE_UNICA_AUTH)}
                            text={uniqueKeyText}
                            image={saInfoCircleGrayIcon}
                            onClickModalTrigger={this.onClickModalTrigger}
                        />}

                        {this.props.stepInfo.authenticationMethods && this.props.stepInfo.authenticationMethods[AM.QUESTIONS_AUTH] &&  <AuthenticationType
                            onChangeHandler={this.onChangeHandler}
                            name={'authentication-type'}
                            value={AM.QUESTIONS_AUTH}
                            checked={this.isValueSelected(AM.QUESTIONS_AUTH)}
                            text={questionsText}
                            image={saInfoCircleGrayIcon}
                            onClickModalTrigger={this.onClickModalTrigger}
                        />}
                        {this.showModal()}
                    </div>
                
                </Grid>
                </PageWithFooter>
            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        stepInfo: state.stepInfo,
        data: state.data,
        stepData: state.stepData,
        showError: state.showError,
        errorType: state.errorType,
        errorMessage: state.errorMessage,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setData: (data) => {
            dispatch(setData(data));
        },
        setErrorMessage(errorMessage) {
            dispatch(setErrorMessage(errorMessage))
        },
        setShowError(showError) {
            dispatch(setShowError(showError));
        },
        setErrorType(errorType) {
            dispatch(setErrorType(errorType));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectAuthenticationType);
